import * as React from "react";
import { Icon, Popup } from "semantic-ui-react";
import { useContext } from "react";
import { store } from "../store";

// tslint:disable-next-line: interface-name
interface Props {
  moreInfo?: boolean;
  infoMessage?: string;
  questionContent: string;
  id?: number;
  isRequired: boolean;
}

const Question: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch } = globalState;

    return (
        // tslint:disable-next-line: max-line-length
    <h5 className="question">
      {props.questionContent} {props.isRequired &&
      <span className="required">(<b>*</b>)</span>}
      {props.moreInfo &&
                // tslint:disable-next-line: max-line-length
                <Popup content={props.infoMessage} trigger={<Icon style={{ marginLeft: "10px" }} inverted={globalState.state.appState.isDarkTheme} color="blue" name="info circle" />} />
        }
    </h5>
    );
  };

export default Question;
